<template>
    <div class="madrid-route__directions">
                <h1>Información útil</h1>
                <div>
                    <span>INICIO</span>
                    <pre>{{ directions.init.init }}</pre>
                    <div>
                        <div :class="{'ox-hidden': isDisabled(directions.init.metro)}">
                            <p>METRO</p>
                            <pre>{{ directions.init.metro }}</pre>
                        </div>
                        <div :class="{'ox-hidden': isDisabled(directions.init.autobus)}">
                            <p>AUTOBÚS</p>
                            <pre>{{ directions.init.autobus }}</pre>
                        </div>
                        <div :class="{'ox-hidden': isDisabled(directions.init.tren)}">
                            <p>TREN</p>
                            <pre>{{ directions.init.tren }}</pre>
                        </div>
                        <div :class="{'ox-hidden': isDisabled(directions.init.bicimad)}">
                            <p>BICIMAD</p>
                            <pre>{{ directions.init.bicimad }}</pre>
                        </div>
                    </div>
                </div>
                
                <div>
                    <span>FINAL</span>
                    <pre>{{ directions.final.final }}</pre>
                    <div>
                        <div :class="{'ox-hidden': isDisabled(directions.final.metro)}">
                            <p>METRO</p>
                            <pre>{{ directions.final.metro }}</pre>
                        </div>
                        <div :class="{'ox-hidden': isDisabled(directions.final.autobus)}">
                            <p>AUTOBÚS</p>
                            <pre>{{ directions.final.autobus }}</pre>
                        </div>
                        <div :class="{'ox-hidden': isDisabled(directions.final.tren)}">
                            <p>TREN</p>
                            <pre>{{ directions.final.tren }}</pre>
                        </div>
                        <div :class="{'ox-hidden': isDisabled(directions.final.bicimad)}">
                            <p>BICIMAD</p>
                            <pre>{{ directions.final.bicimad }}</pre>
                        </div>
                    </div>
                </div>
            </div>
</template>
<script lang="ts" src="./DirectionsComponent.ts"></script>
<style lang="scss" src="./DirectionsComponent.scss"></style>
